import React, { useState, useEffect } from "react";
import { Checkbox } from "antd";
import styles from "./styles.module.scss";
import ModalBox from "@components/ui-kit/ModalBox";
import { Select } from "@components/ui-kit/Select";

interface WaterfallModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedChannel: "Amazon" | "Shopify" | "TikTok";
  setSelectedChannel: (channel: "Amazon" | "Shopify" | "TikTok") => void;
}

export const WaterfallModal: React.FC<WaterfallModalProps> = ({
  isOpen,
  onClose,
  selectedChannel,
  setSelectedChannel,
}) => {
  const [isChannelChecked, setIsChannelChecked] = useState(!!selectedChannel);
  const [tempChannel, setTempChannel] = useState<
    "Amazon" | "Shopify" | "TikTok"
  >(selectedChannel);

  useEffect(() => {
    if (isOpen) {
      setTempChannel(selectedChannel);
    }
  }, [isOpen, selectedChannel]);

  const handleApply = () => {
    setSelectedChannel(tempChannel);
    onClose();
  };

  const handleReset = () => {
    setTempChannel("Amazon");
  };

  const handleChannelCheckboxChange = (checked: boolean) => {
    setIsChannelChecked(checked);
    if (!checked) {
      setTempChannel("Amazon");
      setSelectedChannel("Amazon");
    }
  };

  const renderChannelTab = () => (
    <div className={styles.tabContent}>
      <div className={styles.selectGroup}>
        <span className={styles.label}>SALES CHANNEL</span>
        <Select
          value={tempChannel}
          onChange={(value: "Amazon" | "Shopify" | "TikTok") =>
            setTempChannel(value)
          }
          className={styles.select}
          options={["TikTok", "Amazon", "Shopify"]}
          placeholder="Select Sales Channel"
        />
      </div>
    </div>
  );

  const renderBrand = () => (
    <div className={styles.tabContent}>
      <div className={styles.selectGroup}>
        <span className={styles.label}>BRAND</span>
        <Select
          value={tempChannel}
          onChange={(value: "Amazon" | "Shopify" | "TikTok") =>
            setTempChannel(value)
          }
          className={styles.select}
          options={["Brand A", "Brand B", "Brand C"]}
          placeholder="Select Brand"
        />
      </div>
    </div>
  );

  return (
    <ModalBox
      isOpen={isOpen}
      onClose={onClose}
      className={styles.waterfallModal}
      title="Total Net Profit Value"
    >
      <div className={styles.modalContent}>
        <p className={styles.description}>
          Choose view and metrics for «Total Net Profit Value»
        </p>

        <div className={styles.filterHeader}>
          <Checkbox
            checked={isChannelChecked}
            onChange={(e) => handleChannelCheckboxChange(e.target.checked)}
          >
            <span className={styles.checkboxLabel}>Sales Channel</span>
          </Checkbox>
        </div>

        {isChannelChecked ? renderChannelTab() : renderBrand()}

        <div className={styles.buttonGroup}>
          <button onClick={handleReset} className={styles.resetButton}>
            RESET TO DEFAULT
          </button>
          <button onClick={handleApply} className={styles.applyButton}>
            APPLY
          </button>
        </div>
      </div>
    </ModalBox>
  );
};
